type ClubOfferData = {
  lpuPrice: number
  couponPrice: number
  cardDateEnd: string | null
  cardPrice: number
  totalPrice: number
}

type ClubUser = {
  isInClub?: boolean
  cardNextPrice?: number
  cardDateEnd?: string | null
}

/**
 * Данные шита клубной цены: половина купоном, карта — если пользователь не в клубе.
 */
export default function getClubOfferData(clubPrice: number): ClubOfferData {
  const couponPrice = Math.floor(clubPrice / 2)
  const club = typeof window === 'undefined'
    ? undefined
    : (window as Window & { USER?: { club?: ClubUser } }).USER?.club
  const cardPrice = club?.isInClub ? 0 : (club?.cardNextPrice || 0)

  return {
    lpuPrice: clubPrice - couponPrice,
    couponPrice,
    cardDateEnd: club?.cardDateEnd || null,
    cardPrice,
    totalPrice: clubPrice + cardPrice,
  }
}
